import React from "react";

const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-[40vh] bg-white">
      <div className="w-10 h-10 border-4 border-orange-400 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
